export default "__VITE_ASSET__BkwnHU4G__"